import React from "react";
import { PageHeader } from "@/components/kit";
import { MembersPanel } from "@/pages/Members";

export default function PeoplePage() {
  return (
    <div>
      <PageHeader title="People" summary="Everyone in the firm, with their team, office and seniority. Usage level is a band, never a score or ranking." testid="people-page-header" />
      <MembersPanel />
    </div>
  );
}
